import styled from 'styled-components'

export const ProfileRoot = styled.div`
  display: flex;
  flex-direction: column;
`

export const IdentityCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  gap: 0.875rem;
  padding: 0.875rem 1rem;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? theme.colors.background
      : theme.colors.borderSubtle};

  @media (max-width: 768px) {
    gap: 0.75rem;
    padding: 0.75rem 0.875rem;
  }
`

export const PhotoRing = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  padding: 2px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.action.primary.bg} 0%,
    ${({ theme }) => theme.colors.action.primary.bgHover} 55%,
    ${({ theme }) => theme.colors.borderStrong} 100%
  );
  box-shadow: 0 4px 12px rgba(62, 207, 142, 0.14);

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
  }
`

export const Photo = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid
    ${({ theme }) =>
      theme.name === 'dark'
        ? theme.colors.background
        : theme.colors.borderSubtle};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? theme.colors.backgroundSecondary
      : theme.colors.background};
`

export const IdentityInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  min-width: 0;
  flex: 1;
`

export const IdentityName = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 0.9375rem;
  }
`

export const IdentityEmail = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.textMuted};
  word-break: break-word;
`

export const RoleList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.375rem;
  margin-top: 0.35rem;
`

export const RoleBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.6875rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-transform: capitalize;
`
